<script>
  import { onMount, createEventDispatcher } from 'svelte';
  
  export let root_id = null;
  export let expanded = true;
  export let items = [];
  export let indent = 0;
  export let json_url = '';
  export let lang = 'cs';
  export let include_root = true;
  export let filtered = {};
  
  const dispatch = createEventDispatcher();
  
  function load() {
    console.log("selectged", filtered)
    if (isNaN(parseInt(+root_id)) || json_url == '') return;
    let url = json_url+"?category="+root_id;
    fetch(url)
      .then(r => r.json())
      .then(data => {
        items = data.length ? list2tree(data) : [];
    });
  }
  
  onMount(load);
  
  function expand(t) {
    if (expanded === true)
      return;
    if (expanded == t)
      expanded = -1;
    else
      expanded = t;
  }
  
  function select(id) {
    filtered[id] = !filtered[id];
    dispatch("setCategory", {category_id: id, value: filtered[id]});
  }
  
  function list2tree(list) {
    var map = {}, node, roots = [], i;
  
    for (i = 0; i < list.length; i += 1) {
      map[list[i].id] = i; // initialize the map
      list[i].children = []; // initialize the children
    }
    for (i = 0; i < list.length; i += 1) {
      node = list[i];
      if (node.parent_id !== "0" && list[map[node.parent_id]]) {
        // if you have dangling branches check that map[node.parent_id] exists
        list[map[node.parent_id]].children.push(node);
      } else {
        roots.push(node);
      }
    }
    return roots;
  }
</script>
{#if items.length }
<ul class:nav-nested='{indent > 0}' class='nav d-flex flex-column'>
{#each items as { id, name, children }, i}
<li>
{#if include_root }
<div class='h6 d-flex justify-content-start text-darker pointer py-1'>
<span class='px-1' on:click='{() => select(id)}'>
<i class:fa-check-square='{filtered[id] && children.length==0}' class:fa-minus='{expanded == i && children.length!=0}' class:fa-plus='{expanded != i && children.length!=0}' class:fa-square='{!filtered[id] && children.length==0}' class='fa mr-1'></i>
{ name[lang] }
</span>
</div>
{/if}
{#if children.length && (expanded == i || expanded === true) }
<svelte:self items="{children}" indent="{indent + 24}" filtered="{filtered}" on:setCategory on:click="{() => select(id)}" />
{/if}
</li>
{/each}
</ul>
{/if}
